<template>
    <NavbarComponent />
    <router-view />
    <FooterComponent />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
    components: {
        NavbarComponent: defineAsyncComponent(() => import('../components/NavbarComponent.vue')),
        FooterComponent: defineAsyncComponent(() => import('../components/FooterComponent.vue')),
    },
    mounted() {
        document.body.classList.remove('escarlata__background')
        document.body.classList.add('background-default')
    }
}
</script>

<style lang="scss" scoped>
</style>
